export enum EError {
  NOT_CONNECTION = '0',
  NOT_FOUND = '404',
  REQUEST_ERROR = '500',
  RESET_SERVER = '1001',

  VIEWER_FAILED = '2001',
  TRACKING_FAILED = '2002',
  CAMERAS_NOT_FOUND = '2003',
}
